import React from 'react';
import '../styles/Footer.css';

const Footer = () => (
  <footer className="footer">
    <p>Made with ☕ in the Woods</p>
    <small>&copy; {new Date().getFullYear()} Will's Portfolio</small>
  </footer>
);

export default Footer;
